export const boolText = (value: boolean) => {
  return value ? 'Ja' : 'Nein'
}
